<div class="row m-0 p-0" [hidden]="urlInvalida">
  <span class="rodape" *ngIf="this.codigoSistema === 5 && !session.whitelabel">{{getYear()}} | Feev Tecnologia</span>
  <span class="rodape rodape-2safe" *ngIf="this.codigoSistema !== 2 && this.codigoSistema !== 7">
    <span>Feev Tecnologia Ltda - 10.406.390/0001-58</span>
    <!-- <span>2020 | Todos os direitos reservados.®</span> -->
  </span>
  <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 m-0 p-0" id="page-login">

    <div class="logo_2safe_branca" *ngIf="this.codigoSistema === 2">
      <img src="../../assets/images/2safe_branco.png" alt="" />
    </div>
    <div class="digital" *ngIf="this.codigoSistema === 2">
      <img src="https://2safe-site.s3.amazonaws.com/digital.png" alt="" />
    </div>

    <!-- <div class="logo_2safe_branca" *ngIf="this.codigoSistema === 7">
      <img src="../../assets/images/acordo-facil-logo-white.png" alt="" />
    </div>
    <div class="atendente" *ngIf="this.codigoSistema === 7">
      <img src="../../assets/images/acordo-atendente.png" alt="" />
    </div> -->

    <div class="landing-acordo-facil" *ngIf="session.whitelabel">
      <div class="acordo-logo">
        <img [src]="session.whitelabel.imagemCabecalho" alt="" class="imagem-whitelabel" />
      </div>
    </div>

    <div class="landing-acordo-facil" *ngIf="this.codigoSistema === 7 && !session.whitelabel">
      <div class="acordo-logo">
        <img src="../../assets/images/acordo-facil-logo-branca.png" alt="" />
      </div>
      <div class="atendente">
        <img src="../../assets/images/acordo-atendente.png" alt="" />
      </div>
    </div>

    <img src="../../assets/images/background/grafismo.png" alt="" class="logo"
      *ngIf="((this.codigoSistema === 5 || this.codigoSistema === 6)  && !session.whitelabel)" />
    <img src="../../assets/images/logofeev_color2.png" alt="" class="logo2"
      *ngIf="((this.codigoSistema === 5 || this.codigoSistema === 6)  && !session.whitelabel)" />

  </div>

  <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 m-0 p-0 login">
    <div class="alert alert-danger alert-dismissible fade show" role="alert" *ngIf="!codigoSistema && !loadingWhitelabel">
      <strong>Erro!</strong> O código do sistema não foi informado corretamente.
    </div>
    <form #frmLogin="ngForm" [hidden]="!codigoSistema">
      <div *ngIf="!alterarSenha" id="card-login" class="d-flex align-items-center justify-content-center shadow-sm">
        <div>
          <div *ngIf="!alterarSenha && !validacaoDados && !mfaPendente" class="entrar-container">
            <div class="text-center">
              <!--Logo-->
              <h1 class="titulo">{{getPlataforma()}}</h1>
            </div>
            <!--Login-->
            <div class="email-senha-container">
              <div class="text-start input-grupo">
                <label for="usuario" class="subtitulo">E-mail ou celular</label>
                <!-- <input name="usuario" id="usuario" class="caixa-texto" type="text" (keyup)="onkeyUp($event)"
                  [(ngModel)]="identificacaoUsuario" title="E-mail ou Celular" /> -->
                <app-input class="caixa-texto" [(ngModel)]="identificacaoUsuario" name="usuario" id="usuario"
                  type="text" (keyup)="onkeyUp($event)"></app-input>
              </div>
              <div class="text-start input-grupo">
                <label for="senha" class="subtitulo">Senha</label>
                <!-- <input name="senha" id="senha" class="caixa-texto" type="password" (keyup)="onkeyUp($event)"
                  [(ngModel)]="senhaAcesso" /> -->
                <app-input class="caixa-texto" [(ngModel)]="senhaAcesso" name="senha" id="senha" type="password"
                  (keyup)="onkeyUp($event)"></app-input>
              </div>
              <div class="d-flex justify-content-between w-100">
                <a class="text-primary esqueceu-senha" href="javascript:;" (click)="recuperarSenha(false)">
                  Esqueceu a
                  senha?
                </a>
                <!--<div class="d-flex">
          <a class="text-primary esqueceu-senha" href="javascript:;" (click)="recuperarSenha(true)">Primeiro acesso?</a>
        </div>-->
              </div>
            </div>
            <div class="login-buttons-container">
              <div class="text-center">
                <button class="btn btn-primary btn-md btn-block" type="button" (click)="acessar()" #btn>
                  Entrar
                </button>
              </div>
              <div class="text-center">
                <button type="button" class="btn-google" title="Acessar com o Google" (click)="autenticarGoogle()">
                  <img src="/assets/images/icon/google.svg" alt="Google" />
                  <span>Entrar com o Google</span>
                </button>
              </div>
            </div>

          </div>
          <div *ngIf="mfaPendente" class="entrar-container mfa-container">
            <div class="mfa-cartao">
              <span class="mfa-cartao__etiqueta">
                <i class="fas fa-shield-alt" aria-hidden="true"></i>
                CÓDIGO DE ACESSO
              </span>
              <span class="mfa-cartao__icone" aria-hidden="true">
                <i class="fas fa-envelope"></i>
              </span>
              <h1 class="mfa-cartao__titulo">Confirmação de acesso</h1>
              <p class="mfa-cartao__texto">
                Enviamos um código de {{ tamanhoCodigoMfa }} caracteres para o seu e-mail e celular cadastrados.
                Ele vale por 10 minutos.
              </p>
            </div>

            <div class="mfa-campo">
              <label class="subtitulo" id="rotulo-codigo-mfa">
                Informe o <strong>código</strong> recebido para prosseguir
              </label>

              <app-codigo-acesso name="codigo-mfa"
                [tamanho]="tamanhoCodigoMfa"
                rotulo="Código de acesso"
                [invalido]="codigoMfaInvalido"
                [(ngModel)]="codigoMfa"
                (completo)="codigoMfaInformado($event)"></app-codigo-acesso>

              <!-- Erro anunciado junto ao campo: quem usa leitor de tela ouve sem sair daqui. -->
              <p class="mfa-campo__erro" role="alert" *ngIf="codigoMfaInvalido">
                Código inválido. Confira os caracteres ou peça um novo.
              </p>
            </div>

            <div class="mfa-reenvio">
              <button type="button" class="btn btn-link mfa-reenvio__botao"
                [disabled]="segundosParaReenviar > 0 || reenviandoCodigo"
                (click)="reenviarCodigoMfa()">
                <ng-container *ngIf="reenviandoCodigo; else rotuloReenviar">Enviando…</ng-container>
                <ng-template #rotuloReenviar>
                  Reenviar código<span class="mfa-reenvio__contador" *ngIf="segundosParaReenviar > 0"> ({{ segundosParaReenviar }})</span>
                </ng-template>
              </button>
            </div>

            <!-- Também aqui: com uma conta só liberada não há modal de seleção depois. -->
            <app-acessos-barrados-ip [acessos]="acessosBarradosIp"></app-acessos-barrados-ip>

            <!-- Sem botão de enviar: a validação dispara sozinha quando a última caixa é
                 preenchida, e um botão que nunca chega a ser clicado só ocupa espaço. -->
            <div class="login-buttons-container">
              <button class="btn btn-link mfa-voltar" type="button" (click)="voltar()">Voltar para o login</button>
            </div>

            <app-confiar-dispositivo *ngIf="perguntarDispositivo"
              [dias]="diasDispositivoConfiavel"
              [processando]="confiandoDispositivo"
              (confirmar)="confiarNoDispositivo()"
              (recusar)="concluirMfa()"></app-confiar-dispositivo>
          </div>
          <!-- Validação de e-mail de celular -->
          <div *ngIf="validacaoDados" class="entrar-container mfa-container">
            <div class="mfa-cartao">
              <span class="mfa-cartao__etiqueta">
                <i class="fas fa-shield-alt" aria-hidden="true"></i>
                PRIMEIRO ACESSO
              </span>
              <span class="mfa-cartao__icone" aria-hidden="true">
                <i class="fas" [ngClass]="iconeValidacaoContato"></i>
              </span>
              <h1 class="mfa-cartao__titulo">Confirmação de contato</h1>
              <p class="mfa-cartao__texto">{{ textoValidacaoContato }}</p>
            </div>

            <div class="mfa-campo" *ngIf="celular">
              <label class="subtitulo">
                Informe o código enviado para o seu <strong>celular</strong>
              </label>

              <app-codigo-acesso name="codigo-celular"
                [tamanho]="tamanhoCodigoContato"
                rotulo="Código enviado ao celular"
                [invalido]="codigoCelularInvalido"
                [(ngModel)]="codigoCelular"
                (completo)="codigoContatoInformado()"></app-codigo-acesso>

              <p class="mfa-campo__erro" role="alert" *ngIf="codigoCelularInvalido">
                Código do celular inválido. Confira os caracteres ou peça um novo.
              </p>
            </div>

            <div class="mfa-campo" *ngIf="email">
              <label class="subtitulo">
                Informe o código enviado para o seu <strong>e-mail</strong>
              </label>

              <app-codigo-acesso name="codigo-email"
                [tamanho]="tamanhoCodigoContato"
                rotulo="Código enviado ao e-mail"
                [invalido]="codigoEmailInvalido"
                [(ngModel)]="codigoEmail"
                (completo)="codigoContatoInformado()"></app-codigo-acesso>

              <p class="mfa-campo__erro" role="alert" *ngIf="codigoEmailInvalido">
                Código do e-mail inválido. Confira os caracteres ou peça um novo.
              </p>
            </div>

            <div class="mfa-reenvio">
              <button type="button" class="btn btn-link mfa-reenvio__botao"
                [disabled]="segundosParaReenviar > 0 || reenviandoCodigo"
                (click)="reenviarCodigoContato()">
                <ng-container *ngIf="reenviandoCodigo; else rotuloReenviarContato">Enviando…</ng-container>
                <ng-template #rotuloReenviarContato>
                  Reenviar código<span class="mfa-reenvio__contador" *ngIf="segundosParaReenviar > 0"> ({{ segundosParaReenviar }})</span>
                </ng-template>
              </button>
            </div>

            <div class="login-buttons-container">
              <button class="btn btn-link mfa-voltar" type="button" (click)="voltar()">Voltar para o login</button>
            </div>
          </div>
        </div>
      </div>
      <!--Alteração de senha-->
      <app-login-alterar-senha (onSenhaAlterada)="continuarLogin($event)"
        *ngIf="alterarSenha"></app-login-alterar-senha>
    </form>
  </div>
</div>

<app-login-recuperar-senha [usuario]="identificacaoUsuario"></app-login-recuperar-senha>
<app-contas-usuario (contaSelecionada)="contaUsuarioSelecionada($event)"></app-contas-usuario>

<!--Modal Selecionar Grupo de Credor e Credor-->
<ng-template #modalGrupoCredor let-c="close" let-d="dismiss">
  <div class="modal-header background-secondary">
    <h4 class="modal-title text-white">Selecione uma conta</h4>
    <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="c(); cancelarAlteracoes()">
    </button>
  </div>
  <div class="modal-body">
    <app-acessos-barrados-ip [acessos]="acessosBarradosIp"></app-acessos-barrados-ip>
    <div class="info-message" *ngIf="contasUsuario.length > 1"
      style="margin-bottom: 15px; font-size: 12px; color: #666; background: #f8f9fa; padding: 10px; border-radius: 5px;">
      Foram encontradas mais de uma conta de usuário para o e-mail/celular informado.
      Selecione uma conta para continuar.
    </div>
    <div *ngIf="contasUsuario.length > 1" style="width: 100%;">
      <app-select name="empresa" [(ngModel)]="hash" title="Conta de Usuário"
        title="Selecione uma conta de usuário para continuar." [disabled]="contasUsuario.length === 1"
        [items]="contasUsuario" bindValue="hash" bindLabel="descricao" (change)="selecionarContaUsuario()"
        style="width: 100%;">
      </app-select>
    </div>
    <div *ngIf="showGrupoCredor" style="width: 100%; margin-top: 10px;">
      <app-select name="empresa" [(ngModel)]="codigoGrupo" title="Grupo de Credores"
        [disabled]="grupoCredores.length === 1" [items]="grupoCredores" bindValue="codigoGrupoCredor"
        bindLabel="nomeGrupoCredor" (change)="carregarCredores($event)" style="width: 100%;">
      </app-select>
    </div>
    <div *ngIf="showGrupoCredor" style="width: 100%; margin-top: 10px;">
      <app-select name="credor" [(ngModel)]="codigoCredor" title="Credores" [disabled]="credores.length === 1"
        [items]="credores" bindValue="codigoCredor" bindLabel="nomeCredor" (change)="selecionarCredor($event)"
        style="width: 100%;">
      </app-select>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="c(); cancelarAlteracoes()">
      Fechar
    </button>
    <button class="btn btn-primary" (click)="selecionarConta()"
      [disabled]="(!codigoGrupo || !codigoCredor ) && !ignoraGrupoCredor">
      Selecionar conta
    </button>
  </div>
</ng-template>
